var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1425,
    height: 920,
    viewBox: "0 0 1425 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_53821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.017 832.686C177.017 832.686 415.537 721.563 749.466 701.866C1083.4 682.168 1250.31 333.032 1250.31 333.032L1425 0.00146484V920.001H0.000976562L177.017 832.686Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.934 869.038C975.211 879.29 1011.09 868.721 1030.65 845.397C1049.2 823.29 1051.47 786.929 1031.28 757.556C1028.89 754.081 1026.25 750.783 1023.39 747.69C1022.4 746.624 1020.93 747.676 1021.87 748.807C1043.82 774.964 1047.34 810.41 1032.85 834.3C1017.84 859.03 985.783 872.258 953.628 867.357C923.32 862.738 891.503 840.267 880.582 809.793C875.692 796.327 875.339 781.607 879.577 767.918C883.815 754.229 892.407 742.337 904.019 734.09C927.035 717.784 961.997 716.547 992.016 731.491C995.539 733.243 998.942 735.233 1002.2 737.449C1004.99 739.347 1007.55 735.867 1004.74 733.875C975.27 712.99 936.535 710.935 909.882 724.251C883.6 737.383 866.788 766.929 872.972 799.536C879.152 832.121 909.157 859.536 940.932 869.04",
    fill: "#F5F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_53821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1425,
    height: 920,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg2.cc9bad1f9ac1de916ade8cac8b4f0799.svg";
export { ForwardRef as ReactComponent };